import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '@share/utils';

import SideNav from "../../components/dashboard/side-nav/component";
import { List, Spin } from "antd";
import { ISavedPropertiesState, getSavedProperties, removeSavedProperties, deleteSavedProperties } from "@store/slices";
import { HeartTwoTone } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { ILoginState } from '@share/store/slices';
import { Base64 } from 'js-base64';
import moment from 'moment';
import { Routes } from '@share/constants';
import "./style.scss"; 
import { FormattedMessage, useIntl } from 'react-intl';

interface IMapStateToProps {
  savedPropertiesStore: ISavedPropertiesState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  getSavedProperties: (filter: string) => void;
  removeSavedProperties: () => void;
  deleteSavedProperties: (propertyId: number) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps { }

function AccountSavedComponent(props: IProps) {
  const history = useHistory();
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const [filter, setFilter] = useState("created");

  const renderStars = (rating) => {
    const fullStars = parseInt(rating);
    const totalStars = 5;
    return Array.from({ length: totalStars }, (_, i) =>
      i < fullStars ? 'bi bi-star-fill text-warning' : 'bi bi-star text-warning',
    );
  };

  useEffect(() => {
    props.getSavedProperties(filter);
  }, [filter]);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const HandleDetail = (e: any, type: string, id: number, name: string) => {
    e.preventDefault();
    name = name.replace(/\s+/g, '-').toLowerCase().replace(/\.|\,/g, '');
    const path = `/${login.account.name}${type === 'hotel' ? Routes.Hotel : Routes.Condo}/${id}/${name}`;
    window.open(path, '_blank');
  }

  const handleSubmit = (code: number) => {
    const now = new Date();
    const checkIn = moment(now).add(1, 'd').format('yyyy-MM-DDThh:mm:ss.000Z');
    const checkOut = moment(checkIn, 'yyyy-MM-DD').add(3, 'd').format('yyyy-MM-DDThh:mm:ss.000Z');
    const dateObject = { checkIn , checkOut };
    const roomsObject = [{ adultsCount: 2, kidsAges: Array(0).fill(0) as number[] }]

    history.push(
      `/${login.account.name}/hotel/${code}?dates=${Base64.encode(JSON.stringify(dateObject),
      )}&rooms=${Base64.encode(JSON.stringify(roomsObject),
      )}&location=${Base64.encode(JSON.stringify({}),
      )}&sessionKey=${Base64.encode(JSON.stringify({}))}`,
    );
  };

  const handleRemoveAll = (e) => {
    e.preventDefault();
    props.removeSavedProperties();
  };

  const handleDelete = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, propertyId: number) => {
    e.preventDefault();
    props.deleteSavedProperties(propertyId);
  };

  const { properties, loading } = props.savedPropertiesStore;
  const intl = useIntl();
  return (
    <section className="pt-3 saved-properties-container">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm border">
              <div className="card-header bg-transparent border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-bookmark-check mx-2"></i><FormattedMessage id="saved.properties" />
                </h4>
              </div>
              <Spin spinning={loading}>
                <div className="card-body vstack">
                  <div className="card">
                    <form className="recent-header">
                      <div className="col-xl-3">
                        <select
                          className="form-select form-select-sm js-choice border-custom"
                          value={filter}
                          onChange={handleFilterChange}
                          placeholder={'Sort by'}
                        >
                          <option value={'created'}>{intl.formatMessage({ id: 'recently.added' })}</option>
                          <option value={'reviewsCount'}>{intl.formatMessage({ id: 'most.popular' })}</option>
                          <option value={'rating'}>{intl.formatMessage({ id: 'top.rated' })}</option>
                        </select>
                      </div>
                      <div className="text-end">
                         <button className="btn btn-danger-soft mb-0 mt-0 mx-0" onClick={handleRemoveAll}>
                            <i className="fas fa-trash me-2"></i><FormattedMessage  id="remove.all" />
                        </button>
                        </div>
                    </form>
                  </div>

                  <hr style={{ width: '-webkit-fill-available' }} />

                  <List
                    itemLayout="vertical"
                    size="large"
                    pagination={{
                      onChange: page => { console.log(page); },
                      pageSize: 3,
                    }}
                    dataSource={properties}
                    renderItem={item => (
                      <List.Item key={item.propertyId}>
                        <div className="card">
                          <div className="row g-0">
                            <div className="col-md-3 gx-0 rounded-2 saved-property-card-image" style={{ backgroundImage: `url(${item.imgSrc})` }}>
                              {/*<img src={item.imgSrc} className="card-img rounded-2" alt="CardImage" />*/}
                            </div>

                            <div className="col-md-9">
                              <div className="card-body py-md-2 d-flex flex-column h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                  <ul className="list-inline small mb-0">
                                    {renderStars(item.rating).map((starClass, index) => (
                                      <li key={index} className="list-inline-item me-0"><i className={starClass}></i></li>
                                    ))}
                                  </ul>
                                  <ul className="list-inline mb-0">
                                    <li className="list-inline-item">
                                      <a href="#" onClick={(e) => handleDelete(e, item.propertyId)}><HeartTwoTone twoToneColor="#f40b0b" style={{ fontSize: 'x-large' }} /></a>
                                    </li>
                                  </ul>
                                </div>

                                <h5 className="card-title mb-1" style={{ height: '60px', paddingRight: '20px' }}><a href="#">{item.name}</a></h5>

                                <small><i className="bi bi-geo-alt me-2"></i>{item.address}</small>

                                <div className="d-sm-flex justify-content-sm-between align-items-center mt-3 mt-md-auto">
                                  <div className="d-flex align-items-center">
                                    <h5 className="fw-bold mb-0 me-1 rating">{item.rating?.toFixed(1)}</h5>
                                    <span className="mb-0 me-2 public_price">({item.reviewsCount} {intl.formatMessage({ id: 'reviews' })})</span>
                                  </div>
                                  <div className="mt-3 mt-sm-0">
                                    {/* <a href="#" onClick={(e) => { e.preventDefault(), handleSubmit(item.propertyId) }} className="btn btn-sm btn-dark w-100 mb-0">View hotel</a> */}
                                    <a href="#" onClick={(e) => HandleDetail(e, item.type, item.propertyId, item.name)} className="btn btn-sm btn-dark w-100 mb-0 mx-0"><FormattedMessage id="view.hotel" /></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </List.Item>
                    )}
                  />
                </div>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    savedPropertiesStore: state.savedPropertiesStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getSavedProperties,
  removeSavedProperties,
  deleteSavedProperties
};

const AccountSaved = connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountSavedComponent));
export default AccountSaved;